import { authActionsInterfaces } from '../redux/auth';

export const createBodyFromError = (error?: authActionsInterfaces.Error, defaultBodyTranslateKey = '') =>
  error && error.komunikat ? error.komunikat : defaultBodyTranslateKey;

export const createBodyFromErrorWithText = (error?: authActionsInterfaces.Error, defaultBodyTranslateKey = '') =>
  error && error.komunikat ? error.komunikat : error && error.text ? error.text : defaultBodyTranslateKey;
